import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Box, Container, Grid, Typography, MenuItem, TextField, Tab, Divider, makeStyles, useTheme} from '@material-ui/core'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import LoadingButton from '@mui/lab/LoadingButton';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import StepperCart from '../components/FormsUI/StepperCart'
import axios from 'axios'
import * as Yup from 'yup'
import { useLocation } from 'react-router-dom'
import { getDomainTlds } from '../services/Product'
import { getPublicIp, getTimeNow } from '../utils/index'
import appConfig from '../config/main.config'
import VerifyDomainOnly from '../components/verify/VerifyDomainOnly';
import { useTranslation } from 'react-i18next';
const api = appConfig.url_api;

const useStyles = makeStyles((theme) => ({
    [theme.breakpoints.down('sm')]: {
        contDomainReg: {
            padding: '0px'
        }
    },
    tab: {
        fontSize: '11px',

        [theme.breakpoints.down('sm')]: {
            padding: '6px 6px',
        },
    },
}));

const SearchDomainOrder = (props) => {
    //const rrr= new URLSearchParams(props.location.search).get("pid")
    //this.props.match.params.id
    //console.log('res', this.props)
    const {t} = useTranslation();
    const classes = useStyles();
    const theme = useTheme();
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    //const confopt = urlParams.get('confopt');
    let tabIni = '1';
    let sld = '';
    let tld = '.com';
    let actionDomain = urlParams.get('action');
    const curcode = urlParams.get('currency');
    
    if(actionDomain === 'transfer') {
        tabIni = '2';
    }
    if(urlParams.get('sld') !== null && urlParams.get('sld') !== ''){
        sld = urlParams.get('sld');
    }
    if(urlParams.get('tld') !== null && urlParams.get('tld') !== ''){
        tld = urlParams.get('tld');
    }

    const [domainRegister, setDomainRegister] = useState('');
    const [domainRegStatus, setDomainRegStatus] = useState('');
    const [tldRegister, setTldRegister] = useState('.com');
    const [loadingButtonReg, setLoadingButtonReg] = useState(false);

    const [domainTransfer, setDomainTransfer] = useState('');
    const [domainTraStatus, setDomainTraStatus] = useState('');
    const [tldTransfer, setTldTransfer] = useState('.com');
    const [loadingButtonTransf, setLoadingButtonTransf] = useState(false);

    const [epp, setEpp] = useState('');

    //selectDomain
    const [loading, setLoading] = useState(true)
    const [items, setItems] = useState([
        { label: t('loading'), value: ".com" }
    ])

    //tabs
    const [valueTab, setValueTab] = useState(tabIni);
    const handleChangeTab = (event, newValue) => {
        setValueTab(newValue);
    }

    async function handleWhoisDomain(dom, ext) {
        const ipv4 = await getPublicIp()
        const today = getTimeNow('yyyy-mm-dd H:MM:ss')
        const domain = dom + ext

        const data = {
            domain: domain,
            date: today,
            ip: ipv4
        };

        axios.post(`${api}/logs/whois/`, data)
            .then(function (response) {
                //console.log(response);
            })
            .catch(function (error) {
                //console.log(error);
            });

    }

    const handleTransferDomain = (dom, ext, epp) => {
        const nombredominio = {
            domain: dom,
            extension: ext
        };
        const domext = dom + ext;

        axios.post(`${api}/domain/isavailable/`, nombredominio)
            .then(function (response) {
                //console.log(response);
                setEpp(epp);
                setDomainTransfer(domext);
                setDomainTraStatus(response.data[domext]["status"]);
                setTldTransfer(ext);
                setLoadingButtonTransf(false);

            })
            .catch(function (error) {
                //console.log(error);
        });

        /*setEpp(epp);
        setDomainTransfer(domext);
        setDomainTraStatus('regthroughothers');
        setTldTransfer(ext);*/

    };

    const handleVerifyDomain = (dom, ext) => {
        const nombredominio = {
            domain: dom,
            extension: ext
        };
        const domext = dom + ext;

        //no olvidar cambiar
        axios.post(`${api}/domain/isavailable/`, nombredominio)
            .then(function (response) {
                //console.log(response);
                const domainData = response.data[domext];

                setEpp('');
                setDomainRegister(domext);
                //setDomainRegStatus(response.data[domext]["status"]);
                setDomainRegStatus(domainData?.costHash ? "unknown" : domainData?.status);
                setTldRegister(ext);
                setLoadingButtonReg(false);

            })
            .catch(function (error) {
                //console.log(error);
        });

        /*setEpp('');
        setDomainRegister(domext);
        //setDomainRegStatus('regthroughus');
        setDomainRegStatus('available');
        setTldRegister(ext);*/

    };

    //Formik
    const initialValues = {
        dominioform: sld,
        extensionform: tld,
        eppform: ''
    }
    const validationSchema = Yup.object().shape({
        dominioform: Yup.string()
            .required(()=>t('required'))
            .matches(/^[aA-zZ0-9-]+$/, ()=>t('domainOnlyLettersNumbers'))
    })
    const onSubmitReg = (values, props) => {
        const dom = values.dominioform.toLowerCase();
        const ext = values.extensionform;
        setLoadingButtonReg(true);
        handleVerifyDomain(dom, ext);
        handleWhoisDomain(dom, ext);
        //props.resetForm()
    }
    const onSubmitTransfer = (values, props) => {
        const dom = values.dominioform.toLowerCase();
        const ext = values.extensionform;
        const epp = values.eppform;
        setLoadingButtonReg(true);
        handleTransferDomain(dom, ext, epp);
        handleWhoisDomain(dom, ext);
    }


    useEffect(() => {
        let unmounted = false;
        async function getTLDs() {
            const body = await getDomainTlds();
            //console.log('tlds', body);

            if (!unmounted) {
                setItems(body.map((domain) => ({ label: domain.extension, value: domain.extension })))
                setLoading(false)
            }
            //const existProd = await getProductAvailable(pid);
            //console.log('salio a buscar product', existProd);
        }

        getTLDs();
        return () => {
            unmounted = true;
        }
    }, [])


    return (
        <>
            <Helmet>
                <title>{t('clientAreaRegisterDomainTitle')}</title>
            </Helmet>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                }}
            >
                <Container maxWidth="md">
                    <Grid item xs={12} md={12}>
                        <Box mt={3} mb={3} >
                            <Typography variant='h4'>{t('domainRegistration')}</Typography>
                            <Divider />
                        </Box>
                        <StepperCart step={0} />
                    </Grid>
                </Container>

                <Container maxWidth="md" variant='cont-nk'>
                    <Grid container>
                        {/* tabs */}
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={valueTab}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
                                        <Tab label={t('registerDomain')} value="1" className={classes.tab} />
                                        <Tab label={t('transferDomain')} value="2" className={classes.tab} />
                                    </TabList>
                                </Box>
                                <TabPanel value="1" className={classes.contDomainReg}>
                                    {/* registrar dominio */}
                                    <Box sx={{ py: 4 }} >
                                        <Grid item xs={12} md={12}>
                                            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmitReg}>
                                                {(props) => (

                                                    <Form>
                                                        <Grid container spacing={2}>

                                                            <Grid item sm={8} xs={7}>
                                                                <Field as={TextField} variant="outlined" name='dominioform' label={t('domain')} fullWidth
                                                                    error={props.errors.dominioform && props.touched.dominioform}
                                                                    helperText={<ErrorMessage name='dominioform' />} required />
                                                            </Grid>
                                                            <Grid item sm={4} xs={5}>
                                                                <Field as={TextField} variant="outlined" name='extensionform' label={t('extension')} select fullWidth>

                                                                    {items.map(({ label, value }) => (
                                                                        <MenuItem key={value} value={value}>
                                                                            {label}
                                                                        </MenuItem>
                                                                    ))}

                                                                </Field>

                                                            </Grid>

                                                            <Grid container justifyContent="flex-end">
                                                                <LoadingButton loading={loadingButtonReg} type='submit' variant='contained' color='primary' sx={{ my: 2 }} > {t('check')} </LoadingButton>
                                                            </Grid>

                                                        </Grid>
                                                    </Form>

                                                )}
                                            </Formik>

                                            <VerifyDomainOnly domainstatus={domainRegStatus} inputdomain={domainRegister} tld={tldRegister} eventDomain='domainregister' epp={epp} curcode={curcode} ></VerifyDomainOnly>
                                        </Grid>
                                    </Box>
                                    {/* registrar dominio */}
                                </TabPanel>
                                <TabPanel value="2" className={classes.contDomainReg}>
                                    {/* transferir dominio */}
                                    <Box sx={{ py: 4 }}>
                                        <Grid item xs={12} md={12}>
                                            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmitTransfer}>
                                                {(props) => (

                                                    <Form>
                                                        <Grid container spacing={2}>

                                                            <Grid item xs={8}>
                                                                <Field as={TextField} variant="outlined" name='dominioform' label={t('domain')} fullWidth
                                                                    error={props.errors.dominioform && props.touched.dominioform}
                                                                    helperText={<ErrorMessage name='dominioform' />} required />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <Field as={TextField} variant="outlined" name='extensionform' label={t('extension')} select fullWidth>

                                                                    {items.map(({ label, value }) => (
                                                                        <MenuItem key={value} value={value}>
                                                                            {label}
                                                                        </MenuItem>
                                                                    ))}

                                                                </Field>

                                                            </Grid>

                                                            <Grid item xs={12} mt={2}>
                                                                <Typography color="colornk.grey3" variant="txtSummary-nk">{t('eppCodeLaterNotice')}</Typography>
                                                            </Grid>

                                                            <Grid item xs={12}>

                                                                <Field as={TextField} variant="outlined" name='eppform' label={t('eppAuthCode')} size="small" fullWidth
                                                                    error={props.errors.eppform && props.touched.eppform}
                                                                    helperText={<ErrorMessage name='eppform' />} />
                                                            </Grid>

                                                            <Grid container justifyContent="flex-end">
                                                                <LoadingButton loading={loadingButtonTransf} type='submit' variant='contained' color='primary' sx={{ my: 2 }}>
                                                                    {t('transfer')}
                                                                </LoadingButton>
                                                            </Grid>

                                                        </Grid>
                                                    </Form>

                                                )}
                                            </Formik>

                                            <VerifyDomainOnly domainstatus={domainTraStatus} inputdomain={domainTransfer} tld={tldTransfer} eventDomain='domaintransfer' epp={epp} curcode={curcode}></VerifyDomainOnly>
                                        </Grid>
                                    </Box>
                                    {/* transferir dominio */}
                                </TabPanel>
                            </TabContext>
                        </Box>

                    </Grid>

                </Container>
            </Box>
        </>
    )
}

export default SearchDomainOrder;
